import { useContext, createContext } from 'react'

const ChartContext = createContext()

export const useDimensionsContext = () => useContext(ChartContext)

const SvgWrapper = ({ dimensions, children }) => (
  <ChartContext.Provider value={dimensions}>
    <svg width={dimensions.width} height={dimensions.height}>
      {children}
    </svg>
  </ChartContext.Provider>
)

export default SvgWrapper
